import { forkJoin, map, Observable, timer } from "rxjs";
import { MatTableDataSourceBackendExtended } from "src/app/shared/classes/datasource-extended";
import { IDataSourceBackendParam, ISampleTemplateInfo } from "../../domain/interfaces/samples.interface";
import { SamplesService } from "../../domain/services/samples.service";

export class SamplesDataSource extends MatTableDataSourceBackendExtended<ISampleTemplateInfo> {
  public rawData$ = this.dataSubject.asObservable();

  constructor(private samplesService: SamplesService) {
    super();
  }

  /**
   * Fetch list of samples matching given parameters.
   * @param params Query parameters including filters, pagination and sorting
   * @return Observable emitting array of sample objects
   */
  public data(params: IDataSourceBackendParam): Observable<ISampleTemplateInfo[]> {
    const request$ = this.samplesService.getSamplesInfos(params) as Observable<ISampleTemplateInfo[]>;
    const minDelay$ = timer(1000); // to show spinner for at least 1sec

    return forkJoin([request$, minDelay$]).pipe(map(([data]) => data));
  }

  /**
   * Fetch total count of samples matching given parameters.
   * @param params Query parameters including filters, pagination and sorting
   * @return Observable emitting total number of samples
   */
  public dataCount(params: IDataSourceBackendParam): Observable<number> {
    return this.samplesService.getSamplesInfosCount(params);
  }
}
